import React, { useState } from 'react';

import ParallelRideInputs from '../inputs/ParallelRideInputs';
import { buildParallelRideDraft } from '../utils/buildParallelRideDraft';

import styles from './ParallelRideStep.module.css';

/**
 * Leaf step for the parallel-ride branch (any reason + parallel checkbox on).
 *
 * Renders only the ride picker. The `outboundTraveling` window (the original
 * driver's travelling start/end for cushioning) is derived from the selected
 * ride's first-station departure and last-station arrival — the UI never
 * asks the dispatcher for these timestamps directly.
 *
 * Emits `{ parallelRideId, outboundTraveling: { fromTimestamp, toTimestamp } }`
 * so the payload mapper's parallelRide case fills in `crewMemberId` (original
 * driver) and forwards the mutation input.
 *
 * @param {import('common/activeElements/modals/FlowModal/flowTypes').FlowNodeComponentProps} props
 */
const ParallelRideStep = ({ data, onDraftChange }) => {
	const [parallelRideId, setParallelRideId] = useState(data?.parallelRideId ?? null);

	const handleRideChange = (nextId, ride) => {
		setParallelRideId(nextId);
		onDraftChange?.(buildParallelRideDraft(nextId, ride, data?.incidentTimestamp));
	};

	return (
		<div className={styles.stack}>
			<ParallelRideInputs
				value={parallelRideId}
				onChange={handleRideChange}
				incidentTimestamp={data?.incidentTimestamp}
			/>
		</div>
	);
};

export default ParallelRideStep;
